import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { UpdateMyProfileData, myProfileApi } from '@/services/api/profile/profile';

export const myProfileKeys = {
  mine: ['me', 'profile'] as const,
};

export function useMyProfileQuery() {
  return useQuery({
    queryKey: myProfileKeys.mine,
    queryFn: () => myProfileApi.get(),
  });
}

export function useUpdateMyProfileMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: UpdateMyProfileData) => myProfileApi.update(data),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: myProfileKeys.mine });
      // The avatar shown by the presence widget comes from the same user row.
      void queryClient.invalidateQueries({ queryKey: ['admin', 'presence'] });
    },
  });
}
